/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.uploadReceipt

import features.uploadReceipt.UploadReceiptApi
import features.uploadReceipt.models.UploadReceiptResponseModel
import features.uploadReceipt.serializeUploadReceiptState
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlinx.serialization.json.Json
import kotlin.js.Promise

/**
 * upload a receipt [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UploadReceiptApi")
class UploadReceiptApiJs {

    /**
     * upload a receipt
     */
    fun uploadReceipt(
        overrideHeaders: String?,
        businessId: String,
        serializedUploadReceiptBodyRequest: String
    ): Promise<String?> {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
            null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
            }
        }

        return GlobalScope.promise {
            val result = UploadReceiptApi().uploadReceipt(
                overrideHeaders = decodedOverrideHeaders,
                businessId = businessId,
                uploadReceiptBodyRequest = Json.decodeFromString(
                    serializedUploadReceiptBodyRequest
                )
            ).toJsonResult<UploadReceiptResponseModel>()

            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    fun observeUploadReceiptState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UploadReceiptApi().uploadReceiptState.serializeUploadReceiptState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}